import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const SkeletonBase = styled.div`
  border-radius: 4px;
  background: var(--PEARL, #ecf1f4);
  background-image: linear-gradient(
    90deg,
    var(--PEARL, #ecf1f4) 0%,
    #f2f5f7 20%,
    var(--PEARL, #ecf1f4) 40%,
    var(--PEARL, #ecf1f4) 100%
  );
  background-size: 800px 104px;
  animation: ${shimmer} 1.2s infinite linear;
`;

export const TableRowSkeleton = styled.div`
  display: flex;
  padding: 24px;
  align-items: center;
  border-bottom: 1px solid #ecf1f4;
`;

export const ProductInfoSkeleton = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SkuSkeleton = styled(SkeletonBase)`
  width: 80px;
  height: 12px;
`;

export const TitleSkeleton = styled(SkeletonBase)`
  width: 180px;
  height: 16px;
`;

export const StatusSkeleton = styled(SkeletonBase)`
  width: 70px;
  height: 20px;
`;

export const PriceSkeleton = styled(SkeletonBase)`
  width: 60px;
  height: 16px;
`;

export const QtySkeleton = styled(SkeletonBase)`
  width: 80px;
  height: 32px;
`;

export const TotalSkeleton = styled.div`
  flex: 1.2;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

export const TotalValSkeleton = styled(SkeletonBase)`
  width: 70px;
  height: 16px;
`;

export const RemoveBtnSkeleton = styled(SkeletonBase)`
  width: 60px;
  height: 16px;
`;

export const SidebarSkeletonCard = styled.div`
  border-radius: 4px;
  border: 1px solid #ecf1f4;
  background: #fff;
  padding: 24px;
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SidebarTitleSkeleton = styled(SkeletonBase)`
  width: 120px;
  height: 16px;
  margin-bottom: 16px;
`;

export const SidebarRowSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  margin-bottom: 8px;
`;

export const SidebarLabelSkeleton = styled(SkeletonBase)`
  width: 60px;
  height: 14px;
`;

export const SidebarValSkeleton = styled(SkeletonBase)`
  width: 50px;
  height: 14px;
`;

export const SidebarButtonSkeleton = styled(SkeletonBase)`
  width: 100%;
  height: 42px;
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const FormLabelSkeleton = styled(SkeletonBase)`
  width: 100px;
  height: 14px;
  margin-bottom: 6px;
`;

export const FormInputSkeleton = styled.div`
  width: 100%;
  height: 38px;
  background: #f7f8f9;
  border-radius: 4px;
`;

export const BreadcrumbSkeleton = styled.div`
  width: 150px;
  height: 24px;
  background: var(--PEARL, #ECF1F4);
  margin-bottom: 20px;
  border-radius: 4px;
`;
